import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Card, Col } from "reactstrap";
import { toast } from "react-toastify";
import axios from "axios";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import CommonTable from "../../../Tables/ReactstrapTables/BasicTables/Common/CommonTable";
import { basicTableHeader2 } from "../../../../Data/Tables/ReactstrapTables/BasicTables";
import { Btn } from "../../../../AbstractElements";
import { baseUrl } from "../../../../Utils/Baseurl/Baseurl";
import { log } from "console";
import api from "../../../../services/api";
interface Token {
  id: string;
  tokenid?: string;
  medicinename?: string;
  finalstatus?: number;
  quotationno?: string;
  taxpercentage?: number;        // ✅ Add this line
  offerdetails?: string;         // ✅ Add this line
  certificates?: {
    quotation: string;
  };
  appointmentdate: string;
  tokenno: string;
  medicalrep?: {
    name: string;
    Company?: {
      companyname: string;
    };
  };
  tokenregistration?: {
    tokenno: string;
    prefix: string;
    appointmentdate: string;
  };
}


const VerificationStatus: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialDate = queryParams.get("date") || "";
  const [selectedDate, setSelectedDate] = useState<string>(initialDate);
  const [tokens, setTokens] = useState<Token[]>([]);

  // Declare finalstatus and reason
  const [finalstatus, setFinalStatus] = useState<number>(0); // Default: Pending (0)
  const [reason, setReason] = useState<string>(""); // Reason (Only required for rejection)

  useEffect(() => {
    fetchTokens();
  }, []);

  const fetchTokens = async () => {
    try {
      const response = await api.get(`${baseUrl}medicinedetails/getAllmedicinedetails`);
      
      if (response.data.data.length === 0) {
        console.log("empty");
        
        // toast.info("No medicine details available.");
      }
      
      setTokens(response.data.data);
    } catch (error) {
      console.error("Error fetching tokens:", error);
      toast.error("Failed to fetch medicine details.");
    }
  };
  

  const handleViewCertificates = async (tokenid?: string) => {
    try {
      if (!tokenid) {
        console.error("Token ID is missing!");
        toast.error("Invalid token ID.");
        return;
      }

      console.log("Passing tokenid:", tokenid);

      // let requestBody: { finalstatus: number; reason?: string } = {
      //   finalstatus,
      // };

      // if (finalstatus === 2) {
      //   requestBody.reason = reason;
      // }

      // await axios.post(
      //   `${baseUrl}medicinedetails/finalapproval/${tokenid}`,
      //   requestBody
      // );

      navigate(`${process.env.PUBLIC_URL}/allcertificates/${tokenid}`);
    } catch (error) {
      console.error("Error updating verification status:", error);
      toast.error("Failed to update verification status.");
    }
  };

  return (
    <>
      <div>
        <Col sm={12}>
          <Card>
            <CommonCardHeader
              title={
                selectedDate
                  ? `Booked Tokens for ${new Date(
                      selectedDate
                    ).toLocaleDateString()}`
                  : "Medicine Details Verified By Purchase Team"
              }
            />
            <div className="table-responsive">
              <CommonTable
                headData={basicTableHeader2}
                headRowClass="border-bottom-info border-top-0"
              >
                {tokens.length > 0 ? (
                  tokens.map((token, index) => (
                    <tr key={index}>
                    <th scope="row">{index + 1}</th>
                    <td>
                      {token.tokenregistration?.prefix || "N/A"}-
                      {token.tokenregistration?.tokenno || "N/A"}
                    </td>
                    <td>{token.medicalrep?.name || "N/A"}</td>
                    <td>{token.medicinename}</td>
                    <td>{token.medicalrep?.Company?.companyname || "N/A"}</td>
                    <td>
                      {token.tokenregistration?.appointmentdate
                        ? new Date(
                            token.tokenregistration.appointmentdate
                          ).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          })
                        : "N/A"}
                    </td>
                  
                    <td>{token.taxpercentage ?? "N/A"}</td> {/* ✅ Tax Percentage */}
                    <td>{token.offerdetails ?? "N/A"}</td>  {/* ✅ Offer Details */}
                  
                    <td>
                      <Btn
                        color="info"
                        onClick={() => handleViewCertificates(token.tokenid)}
                      >
                        View Certificates
                      </Btn>
                    </td>
                    <td>
                      {token.finalstatus === 2 ? (
                        <span className="text-danger">Rejected</span>
                      ) : token.finalstatus === 0 ? (
                        <span className="text-warning">Not Verified</span>
                      ) : (
                        <span className="text-success">Verified</span>
                      )}
                    </td>
                  </tr>
                  
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center">
                      No data found
                    </td>
                  </tr>
                )}
              </CommonTable>
            </div>
          </Card>
        </Col>
      </div>
    </>
  );
};

export default VerificationStatus;
